import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AuditModal from "@/components/AuditModal";
import BlobCursor from "@/components/BlobCursor";
import ScrollProgressBar from "@/components/ScrollProgressBar";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Portfolio from "@/pages/Portfolio";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function AppShell() {
  const [auditOpen, setAuditOpen] = useState(false);
  const openAudit = () => {
    setAuditOpen(true);
    sessionStorage.setItem("pc_audit_seen", "1");
  };
  const closeAudit = () => setAuditOpen(false);

  // Auto-open audit modal once after 25s if user hasn't seen/triggered it yet
  useEffect(() => {
    if (sessionStorage.getItem("pc_audit_seen")) return;
    const timer = setTimeout(() => {
      if (!sessionStorage.getItem("pc_audit_seen")) {
        setAuditOpen(true);
        sessionStorage.setItem("pc_audit_seen", "1");
      }
    }, 25000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <ScrollProgressBar />
      <BlobCursor />
      <ScrollToTop />
      <Navbar onOpenAudit={openAudit} />
      <Routes>
        <Route path="/" element={<Home onOpenAudit={openAudit} />} />
        <Route path="/services" element={<Services onOpenAudit={openAudit} />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost onOpenAudit={openAudit} />} />
        <Route path="/contact" element={<Contact onOpenAudit={openAudit} />} />
        <Route path="*" element={<Home onOpenAudit={openAudit} />} />
      </Routes>
      <Footer onOpenAudit={openAudit} />
      <AuditModal open={auditOpen} onClose={closeAudit} />
    </>
  );
}

function App() {
  return (
    <div className="App noise">
      <LanguageProvider>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
